import React from 'react';

interface ListEntryProps {
    elementValue: string;
    inputValue: string;
}

const ListEntry = ({ elementValue, inputValue }: ListEntryProps): JSX.Element => {
    const index = elementValue.toLowerCase().indexOf(inputValue.toLowerCase());

    if (index < 0) return <>{elementValue}</>;

    return (
        <span>
            {elementValue.slice(0, index)}
            <strong>{elementValue.slice(index, index + inputValue.length)}</strong>
            {elementValue.slice(index + inputValue.length)}
        </span>
    );
};

export default ListEntry;
